!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define("to-querystring", [], t) : "object" == typeof exports ? exports["to-querystring"] = t() : e["to-querystring"] = t();
}("undefined" != typeof self ? self : this, function () {
  return function (e) {
    function t(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return e[r].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var n = {};
    return t.m = e, t.c = n, t.d = function (e, n, r) {
      t.o(e, n) || Object.defineProperty(e, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, t.n = function (e) {
      var n = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(n, "a", n), n;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "", t(t.s = 0);
  }([function (e, t, n) {
    "use strict";

    function r(e, t, n, r, o) {
      var f = r ? o.arrayPrefix || "" : "";

      if ("object" === (void 0 === t ? "undefined" : i(t))) {
        return "" + u(t, "" + n + ("" + e + f + (n && "]") + "["), o);
      }

      return n && n.length ? "" + n + e + "]" + f + "=" + encodeURIComponent(t) : "" + e + f + "=" + encodeURIComponent(t);
    }

    function o(e, t, n) {
      var o = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
      return t.map(function (t) {
        return r(e, t, n, !0, o);
      }).join("&");
    }

    function u(e) {
      var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "",
          n = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {},
          u = [];
      return u = Array.isArray(e) ? e.map(function (e, o) {
        return r("" + o, e, t, !0, n);
      }) : Object.keys(e).filter(function (t) {
        return void 0 !== e[t];
      }).map(function (u) {
        return e[u] && Array.isArray(e[u]) ? o("" + u, e[u], t, n) : r(u, e[u], t, !1, n);
      }), u.join("&").replace(/%20/g, "+");
    }

    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var i = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
      return typeof e;
    } : function (e) {
      return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
    };
    t.default = u;
  }]);
});